import { useLang } from "@/i18n/LanguageContext";
import { LegalPage } from "./LegalPage";

export function PrivacyPage() {
  const { t } = useLang();
  return (
    <LegalPage eyebrow={t("Juridisch", "Legal")} title={t("Privacyverklaring", "Privacy statement")}>
      <p style={{ color: "var(--grey-text)" }}>{t("Laatst bijgewerkt: juni 2026.", "Last updated: June 2026.")}</p>

      <p>
        {t(
          "OnboardForge is een product van Haan Software Solutions (KVK 42089833). In OnboardForge verwerken wij persoonsgegevens van medewerkers namens de werkgever die de dienst afneemt. De werkgever is de verwerkingsverantwoordelijke; wij treden op als verwerker. Voor de afspraken tussen werkgever en ons geldt de ",
          "OnboardForge is a product of Haan Software Solutions (Dutch CoC 42089833). Within OnboardForge we process employees' personal data on behalf of the employer using the service. The employer is the data controller; we act as the processor. The terms between the employer and us are set out in the ",
        )}
        <a href="/dpa">{t("verwerkersovereenkomst", "data processing agreement")}</a>.
      </p>

      <h3>{t("Welke gegevens verwerken we", "What data we process")}</h3>
      <ul>
        <li>{t("Account: naam, e-mailadres, rol en (gehasht) wachtwoord.", "Account: name, e-mail, role and (hashed) password.")}</li>
        <li>{t("Profiel: functie, afdeling, team, locatie, startdatum en taalvoorkeur.", "Profile: job title, department, team, location, start date and language preference.")}</li>
        <li>{t("Voortgang: afgeronde stappen, 'gelezen en begrepen'-akkoorden (met tijdstip en IP-adres) en kennischeck-resultaten.", "Progress: completed steps, 'read and understood' acknowledgements (with timestamp and IP address) and knowledge-check results.")}</li>
        <li>{t("Logging: technische audit-gebeurtenissen voor beveiliging en compliance.", "Logging: technical audit events for security and compliance.")}</li>
      </ul>

      <h3>{t("Doel en grondslag", "Purpose and basis")}</h3>
      <p>
        {t(
          "De gegevens worden uitsluitend gebruikt om de onboarding/kennisbank te leveren en om naleving aantoonbaar te maken. De grondslag bepaalt de werkgever (doorgaans uitvoering van de arbeidsovereenkomst en/of een wettelijke verplichting).",
          "The data is used solely to deliver the onboarding/knowledge base and to evidence compliance. The legal basis is determined by the employer (typically performance of the employment contract and/or a legal obligation).",
        )}
      </p>

      <h3>{t("Cookies en opslag", "Cookies and storage")}</h3>
      <p>
        {t(
          "De applicatie gebruikt alleen functionele lokale opslag (een inlogtoken en je taalvoorkeur). Er worden geen tracking- of advertentiecookies geplaatst en er is geen profilering.",
          "The application uses only functional local storage (a login token and your language preference). No tracking or advertising cookies are set, and there is no profiling.",
        )}
      </p>

      <h3>{t("Bewaartermijn", "Retention")}</h3>
      <p>
        {t(
          "Gegevens worden bewaard zolang het account actief is en daarna conform de afspraken met de werkgever. Bij beëindiging worden de gegevens van de organisatie geëxporteerd en volledig verwijderd.",
          "Data is retained while the account is active and thereafter in line with the agreement with the employer. On termination the organisation's data is exported and fully deleted.",
        )}
      </p>

      <h3>{t("Subverwerkers", "Sub-processors")}</h3>
      <p>
        {t(
          "Wij maken gebruik van een hostingpartij (binnen de EER) en een e-mailprovider voor transactionele e-mail. Een actuele lijst is op aanvraag beschikbaar.",
          "We use a hosting provider (within the EEA) and an e-mail provider for transactional e-mail. A current list is available on request.",
        )}
      </p>

      <h3>{t("Je rechten", "Your rights")}</h3>
      <p>
        {t(
          "Verzoeken tot inzage, correctie, verwijdering of overdracht lopen via je werkgever (de beheerder). Beheerders kunnen alle gegevens van hun organisatie exporteren en een account verwijderen. Vragen kun je stellen via ",
          "Requests for access, correction, deletion or portability run via your employer (the administrator). Administrators can export all of their organisation's data and delete an account. Questions can be sent to ",
        )}
        <a href="mailto:privacy@haansoftwaresolutions.nl">privacy@haansoftwaresolutions.nl</a>.
      </p>

      <p style={{ color: "var(--grey-text)", fontSize: 13.5, marginTop: 20 }}>
        {t(
          "Deze tekst is opgesteld als heldere standaardverklaring. Laat 'm vóór commercieel gebruik nog toetsen aan je specifieke situatie.",
          "This text is provided as a clear standard statement. Have it reviewed against your specific situation before commercial use.",
        )}
      </p>
    </LegalPage>
  );
}
